'use strict';

var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');
var FileSaver = require('file-saver');

module.exports = /*@ngInject*/ ["$filter", "$q", "TrainScheduleFactory", "LocaleFactory", "SchedulingResourceService", "TimeZoneFactory", function TrainScheduleExportFactory($filter, $q, TrainScheduleFactory, LocaleFactory, SchedulingResourceService, TimeZoneFactory) {
    var factory = {
        getExportPlanningCsvString: getExportPlanningCsvString,
        getExportTimetableCsvString: getExportTimetableCsvString,
        parseTimetableCsv: parseTimetableCsv,
        getExportReportCsvString: getExportReportCsvString,
        parseTrainScheduleTableCsv: parseTrainScheduleTableCsv
    };

    return factory;

    /*
     FUNCTIONS
     */

    function getExportPlanningCsvString(schedule) {
        var csvString = "";

        schedule.sort(function (a, b) {
            return a.trainId - b.trainId;
        });

        schedule.forEach(function (scheduleEntry) {
            csvString += parseSchedule(scheduleEntry);
        });
        return csvString;
    }

    function getExportReportCsvString(scheduleDate) {
       
        if(scheduleDate === null || scheduleDate === undefined || !angular.isDate(scheduleDate)) {
            scheduleDate = new Date();
        }

        // checks if the date is valid date or not
        if (angular.isDate(scheduleDate)) {
            SchedulingResourceService.preparedReportByDate().get({ 'scheduleDate': TimeZoneFactory.format(scheduleDate) }).$promise.then(function (value) {

                var csvString = "";

                for (var item in value) {
                    if (!isNaN(item)) {
                        csvString += value[item].toString();
                    }
                }

                var blob = new Blob([csvString], { type: 'text/plain;charset=utf-8' });
                var fileName = '' + $filter('tzdate')(scheduleDate, 'YYYY-MM-DD') + ''
                    + '_' + 'report' +
                    '.csv';

                FileSaver.saveAs(blob, fileName);

            }).catch(function(err) {
                console.log('Error in TrainScheduleExportFactory : getExportReportCsvString() method : ' + JSON.stringify(err));
            });
        }
    }

    function getExportTimetableCsvString(timetable) {
        var separator = LocaleFactory.getCurrentLocaleConfig().separator;
        var csvString = "";
        timetable.forEach(function (timetableEntry) {
            csvString += parseTimetableEntry(timetableEntry, separator);
        });
        return csvString;
    }

    function createTimetableEntry(csvRow) {
        var currentLocaleConfig = LocaleFactory.getCurrentLocaleConfig();
        var data = csvRow.split(currentLocaleConfig.separator);
        if (data.length === 5 || data.length === 6) {
            return {
                serviceId: data[0],
                start: data[1],
                end: data[2],
                startStation: data[3],
                endStation: data[4]
            };
        } else {
            return undefined;
        }
    }

    function parseSchedule(scheduleEntry) {

        var separator = LocaleFactory.getCurrentLocaleConfig().separator;

        return "" + scheduleEntry.projectId + separator +
            scheduleEntry.trainId + separator +
            scheduleEntry.timeTableEntry.serviceId + separator +
            scheduleEntry.timeTableEntry.start.replace(/'/g, "") + separator +
            scheduleEntry.timeTableEntry.end.replace(/'/g, "") + separator
            + scheduleEntry.timeTableEntry.startStationAbbr + separator +
            scheduleEntry.timeTableEntry.endStationAbbr + "\n";
    }

    function parseTimetableEntry(timetableEntry, separator) {
        var startDate = $filter('date')(timetableEntry.start, 'HH:mm');
        var arrivalDate = $filter('date')(timetableEntry.end, 'HH:mm');
        return "" + timetableEntry.serviceId + separator + startDate + separator + arrivalDate + separator
            + timetableEntry.startStation + separator + timetableEntry.endStation + "\n";
    }


    function parseTrainScheduleTableCsv(csv) {
        var deferred = $q.defer();
        var trainScheduleEntities = {};
        var rows = csv.split('\n');
        var startIndex = 0;
        var error;
        for (var i = startIndex; i < rows.length; i++) {
            var currentTrainScheduleRow = rows[i].trim().split(LocaleFactory.getCurrentLocaleConfig().separator);
            if (currentTrainScheduleRow[0]) {
                var trainRelativeId = currentTrainScheduleRow[0]; // is there any way to validate the train relative id at this point?
                currentTrainScheduleRow.shift(); // Remove the column containing the train relative Id
                if (currentTrainScheduleRow && currentTrainScheduleRow.length > 0) {
                    if (!trainScheduleEntities[trainRelativeId]) {
                        trainScheduleEntities[trainRelativeId] = {
                            trainRelativeId: trainRelativeId,
                            serviceIds: []
                        };
                    }
                    var uniqueServiceIds = trainScheduleEntities[trainRelativeId].serviceIds.concat(currentTrainScheduleRow)
                        .filter(function(serviceId) { return !!serviceId;})
                        .filter(function(value, index, self) {
                            return self.indexOf(value) === index;
                        });
                    trainScheduleEntities[trainRelativeId].serviceIds = uniqueServiceIds;
                }
            }
        }
        if (!util.isDefined(error)) {
            deferred.resolve(Object.keys(trainScheduleEntities).map(function(key) {
                return trainScheduleEntities[key];
            }));
        } else {
            deferred.reject(error);
        }
        return deferred.promise;
    }

    function parseTimetableCsv(csv, waypoints) {
        var deferred = $q.defer();
        var timetable = [];
        var rows = csv.split('\n');
        var startIndex = 1;
        var error;
        for (var i = startIndex; i < rows.length; i++) {
            var entry = createTimetableEntry(rows[i].trim());
            if (!util.isDefined(entry) && i !== rows.length - 1) {
                error = 'Unable to split row by separator. Perhaps export was done with different seperator than import. Verify your selected locale.';
                break;
            }
            if (i === rows.length - 1) {
                error = undefined;
                break;
            }
            var rowError = verifyTimetableRow(entry, waypoints);
            if (util.isDefined(rowError)) {
                error = rowError + ' on line[' + (i + 1) + ']: ' + rows[i];
                break;
            } else {
                var trainTripPeriod = {
                    serviceId: entry.serviceId,
                    start: entry.start,
                    end: entry.end,
                    startStation: entry.startStation,
                    endStation: entry.endStation
                };
                timetable.push(trainTripPeriod);
            }
        }
        if (!util.isDefined(error)) {
            deferred.resolve(timetable);
        } else {
            deferred.reject(error);
        }
        return deferred.promise;
    }

    /*
     PRIVATE FUNCTIONS
     */

    function verifyTimetableRow(entry, waypoints) {
        var errorMsg;
        if (entry.serviceId.length > 45) {
            errorMsg = 'Error - invalid service id: \"' + entry.serviceId + '\"';
        } else if (entry.start.indexOf(':') === -1 || entry.start.length !== 8) {
            errorMsg = 'Error - invalid start: \"' + entry.start + '\"';
        } else if (entry.end.indexOf(':') === -1 || entry.end.length !== 8) {
            errorMsg = 'Error - invalid end: \"' + entry.end + '\"';
        } else if (entry.startStation.length === 0 || !validWaypointAbbreviation(entry.startStation, waypoints)) {
            errorMsg = 'Error - invalid startStation: \"' + entry.startStation + '\"';
        } else if (entry.endStation.length === 0 || !validWaypointAbbreviation(entry.endStation, waypoints)) {
            errorMsg = 'Error - invalid endStation: \"' + entry.endStation + '\"';
        }

        var dateParts = entry.start.split(':').length + entry.end.split(':').length;
        //10:00:00 --> 10 00 00
        if(dateParts !== 6){
            errorMsg = 'Invalid time notation: \"' + entry.start + ' or ' + entry.end + '\" example: 10:00:00';
        }
        return errorMsg;
    }

    function validWaypointAbbreviation(abbr, waypoints) {
        return util.isDefined(arrayUtil.getFirstInList(waypoints, 'abbreviation', abbr.trim()));
    }

}];
